<script setup lang="ts">
import { provide, ref, watch } from 'vue';
import SendCardConfirmDialog from '@/components/user/SendCardConfirmDialog.vue';
import { useCouponStore } from '@/store/couponStore';
import useGlobalStore from '@/store/globalStore';
import { MBrandTab } from '@nio-fe/brand-mix-ui';
import { asyncVueComponent } from '@nio-fe/mate-lib-loader';
const props = defineProps<{
  theme: string;
}>();
const couponStore = useCouponStore();
const globalStore = useGlobalStore();
const availableBrands = globalStore.getBrandsFromBrandAccounts();
if (availableBrands?.length) {
  couponStore.currentBrand = availableBrands[0];
}
const TitCouponCard = asyncVueComponent(
  '@nio-wad/ladybird',
  '0',
  'TitCouponCard'
);
const sendCardConfirmDialogRef = ref<typeof SendCardConfirmDialog | null>(null);
const visible = ref(false);

const showPopover = () => {
  visible.value = true;
};

const hidePopover = () => {
  visible.value = false;
};

const handleSendCoupon = (coupon) => {
  sendCardConfirmDialogRef.value?.showDialog({
    selected: coupon,
  });
};
const getCurrentVisibleStatus = () => {
  return visible.value;
};

watch([visible, () => couponStore.currentBrand], () => {
  if (visible.value) {
    couponStore.fetchCoupon();
  }
});

defineExpose({
  showPopover,
  hidePopover,
  getCurrentVisibleStatus,
});
</script>

<template>
  <div
    v-show="visible"
    :class="{
      'tit-coupon-popover': true,
      'tit-coupon-popover--position-left': theme === 'v2',
    }"
  >
    <h3>我的卡券</h3>
    <div v-if="availableBrands?.length > 1" class="tit-coupon-popover__brand">
      <m-brand-tab
        v-model="couponStore.currentBrand"
        :available-brands="availableBrands"
      />
    </div>
    <div class="tit-coupon-popover__list">
      <template v-if="couponStore.list.length">
        <tit-coupon-card
          v-for="item in couponStore.list"
          :key="item.couponIssueId"
          v-tit-tracker:expose="{
            trackName: 'CouponView',
            requirement_id: 522,
            page: '我的卡券',
            track_sign: 'aplatform.b2443.pageview.CouponView',
          }"
          :coupon="item"
          class="coupon-item"
          :status="item.inTransferring ? '转赠中' : ''"
        >
          <template #footer>
            <n-button
              v-if="item.transferable"
              v-tit-tracker:click="{
                trackName: 'CouponClick',
                requirement_id: 522,
                track_sign: 'aplatform.b2443.d2445.click.CouponClick',
                coupon_name: item?.subTitle,
                button_name: '赠送',
                coupon_id: item?.couponIssueId,
                page: '我的卡券',
              }"
              size="mini"
              @click="handleSendCoupon(item)"
              >赠送</n-button
            >
          </template>
        </tit-coupon-card>
      </template>

      <n-empty v-if="!couponStore.list.length" description="当前暂无卡券" />
    </div>
  </div>
  <send-card-confirm-dialog ref="sendCardConfirmDialogRef" />
</template>

<style scoped lang="scss">
.tit-coupon-popover {
  position: fixed;
  right: 248px;
  width: 368px;

  top: 0px;
  z-index: 10;
  background: #ffffff;

  box-shadow: 0px 5px 15px 2px rgba(0, 0, 0, 0.08);
  border-radius: 8px;

  &--position-left {
    right: auto;
    left: 248px;
  }
  > h3 {
    padding: 16px 24px 8px;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    color: #242629;
    font-weight: 600;
    margin-bottom: 0;
  }
  &__brand {
    padding: 16px 24px;
    padding-bottom: 0;
  }
  &__list {
    padding: 16px 24px;
    height: 540px;
    overflow: auto;
  }
}

.coupon-item {
  margin-bottom: 12px;
}
</style>
